import { useObserver } from 'mobx-react-lite';

import useCart from 'hooks/use-cart';

export default function useAddress() {
  const cart = useCart();
  return useObserver(() => cart?.formattedAddress);
}
